module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "files-root"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "section-body"
    }
  }, [_c('div', {
    staticClass: "col l6 files",
    staticStyle: {
      "padding": "2.5em"
    }
  }, [_c('div', {
    staticClass: "row flex",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.4em",
      "vertical-align": "middle"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "uploadfile",
      "accept": ".stl",
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "a3d btn small upload",
    on: {
      "click": function($event) {
        return _vm.selectUploadFile()
      }
    }
  }, [_vm._v("\n                    Upload new file\n                ")]), _vm._v(" "), (_vm.files.length > 0) ? _c('button', {
    staticClass: "a3d btn small create-nested",
    on: {
      "click": function($event) {
        return _vm.toggleNestedMode()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.nestedMode ? 'Cancel' : 'Create') + " nested job\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.deleting || _vm.uploading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.message) + "\n            ")]), _vm._v(" "), (_vm.files.length < 1 && !_vm.filesPagination.loading) ? _c('div', {
    staticClass: "no-files center-align"
  }, [_vm._v("\n                There are no files yet\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: file.pathKey,
      staticClass: "a3d file"
    }, [_c('div', {
      staticStyle: {
        "margin-right": "1em"
      }
    }, [(!_vm.nestedMode) ? _c('i', {
      staticClass: "material-icons a3d color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteF(file)
        }
      }
    }, [_vm._v("\n                       clear\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.nestedMode) ? _c('input', {
      staticClass: "filled-in",
      attrs: {
        "type": "checkbox",
        "id": file.pathKey
      },
      domProps: {
        "checked": _vm.filesNested[file.pathKey]
      },
      on: {
        "change": function($event) {
          return _vm.setNestedFile(file)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": file.pathKey
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "file-name-nested"
    }, [_vm._v("\n                    " + _vm._s(file.name) + "\n                ")]), _vm._v(" "), (file.isVirus) ? _c('div', {
      staticClass: "file-error"
    }, [_vm._v("\n                  File is infected\n                ")]) : _c('div', {
      staticClass: "button-block right"
    }, [(file.isInvalidStlFile) ? _c('div', {
      staticClass: "file-error"
    }, [_vm._v("\n                      File is corrupted\n                    ")]) : _vm._e(), _vm._v(" "), ((!file.fixOperation || file.fixOperation.status === 'DRAFT' || file.fixOperation.status === 'SUBMITTED') && !_vm.user.isGovcloudUser && !file.isInvalidStlFile) ? _c('button', {
      staticClass: "a3d btn small inv",
      attrs: {
        "disabled": _vm.repairProcess[file.id]
      },
      on: {
        "click": function($event) {
          return _vm.fileRepairOpen(file)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.repairProcess[file.id] ? 'Repairing...' : 'Repair File') + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "a3d btn small inv",
      on: {
        "click": function($event) {
          return _vm.fileDownload({
            filename: file.name,
            sourceFilePathKey: file.pathKey
          })
        }
      }
    }, [_vm._v("Download")]), _vm._v(" "), (!file.isInvalidStlFile) ? _c('router-link', {
      staticClass: "a3d btn small",
      attrs: {
        "to": {
          name: 'CreateJob',
          params: {
            id: file.id
          }
        }
      }
    }, [_vm._v("\n                        Create job\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.repairProcess[file.id]) ? _c('div', {
      staticClass: "progress"
    }, [(true) ? _c('div', {
      staticClass: "indeterminate"
    }) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), (_vm.deleting || _vm.filesPagination.loading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e(), _vm._v(" "), (!_vm.filesPagination.isAllLoaded && _vm.filesFormatted.length > 0 && !_vm.filesPagination.loading) ? _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn load-files",
    attrs: {
      "disabled": _vm.filesPagination.loading || _vm.uploading || _vm.deleting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadSourceFiles()
      }
    }
  }, [_vm._v("Load more")])]) : _vm._e(), _vm._v(" "), (_vm.nestedMode && Object.keys(_vm.filesNested).length > 0) ? _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.nestParts()
      }
    }
  }, [_vm._v("Nest selected parts")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col l6 jobs a3d",
    staticStyle: {
      "padding": "2.5em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.loadingJobs) ? _c('div', {
    staticClass: "progress"
  }, [(!_vm.jobsProgress.loaded) ? _c('div', {
    staticClass: "indeterminate"
  }) : _c('div', {
    staticClass: "determinate",
    style: ('width: ' + (_vm.jobsProgress.loaded / _vm.jobsProgress.total) * 100 + '%')
  })]) : _c('div', [(_vm.filesFormatted.length > 0) ? _c('div', {
    staticClass: "right-align"
  }, [(_vm.compareMode && (Object.keys(_vm.filesCompare).length > 0 || Object.keys(_vm.nestedFilesCompare).length > 0)) ? _c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.showEstimateModal()
      }
    }
  }, [_vm._v("\n                            Compare\n                          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.toggleCompareMode()
      }
    }
  }, [_vm._v(_vm._s(_vm.compareMode ? 'Cancel comparing' : 'Compare Print Costs'))]), _vm._v(" "), (!_vm.showArchived && _vm.countArchivedJobs > 0) ? _c('a', {
    staticClass: "a3d btn inv",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleArchived.apply(null, arguments)
      }
    }
  }, [_vm._v("View Archived Jobs")]) : _vm._e(), _vm._v(" "), (_vm.showArchived && _vm.countActiveJobs > 0) ? _c('a', {
    staticClass: "a3d btn inv",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleArchived.apply(null, arguments)
      }
    }
  }, [_vm._v("View Active Jobs")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showArchived && _vm.countArchivedJobs < 1) ? _c('div', {
    staticClass: "a3d file job"
  }, [_c('div', {
    staticClass: "message center-align"
  }, [_vm._v("\n                            There are no archived jobs yet\n                        ")])]) : _vm._e(), _vm._v(" "), (!_vm.showArchived && _vm.countActiveJobs < 1) ? _c('div', {
    staticClass: "a3d file job"
  }, [_c('div', {
    staticClass: "message center-align"
  }, [_vm._v("\n                            There are no created jobs yet\n                        ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filesFormatted), function(file, index) {
    return _c('div', {
      key: file.jobId ? file.jobId : file.id
    }, [(file.isNested) ? [(file.isArchived === _vm.showArchived) ? _c('job-output', {
      attrs: {
        "job": file,
        "compare-mode": _vm.compareMode
      }
    }) : _vm._e()] : [_c('file-output', {
      attrs: {
        "file": file,
        "show-archived": _vm.showArchived,
        "compare-mode": _vm.compareMode
      }
    })]], 2)
  }), _vm._v(" "), (_vm.jobsPagination.loading) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "padding-top": "3px"
    }
  }, [_c('modal', {
    ref: "removemodal",
    attrs: {
      "name": "removemodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "300px"
    },
    on: {
      "before-open": _vm.removeJobOpen
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Are you sure that you want to delete this job?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.removeJob()
      }
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.removeJobConfirmationCancel()
      }
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('modal', {
    ref: "repairmodal",
    attrs: {
      "name": "repairmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "400px"
    },
    on: {
      "closed": _vm.fileRepairClose
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "repair-form"
  }, [_c('div', {
    staticClass: "block-input-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "block-description"
  }, [_vm._v("\n                                      Mesh envelope size\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repairConfig.tetraEps.current),
      expression: "repairConfig.tetraEps.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraEpsField"
    },
    domProps: {
      "value": (_vm.repairConfig.tetraEps.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.repairConfig.tetraEps)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repairConfig.tetraEps, "current", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block-note"
  }, [_vm._v("Small envelope size improves accuracy but increases run time")]), _vm._v(" "), (_vm.repairConfig.tetraEps.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-input-wrp"
  }, [_c('div', {
    staticClass: "block-input"
  }, [_c('div', {
    staticClass: "block-description"
  }, [_vm._v("\n                                      Tetra mesh size\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "block-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repairConfig.tetraMeshSize.current),
      expression: "repairConfig.tetraMeshSize.current"
    }],
    staticClass: "validate",
    attrs: {
      "type": "text",
      "id": "tetraMeshSizeField"
    },
    domProps: {
      "value": (_vm.repairConfig.tetraMeshSize.current)
    },
    on: {
      "change": function($event) {
        return _vm.verifyNumPositive(_vm.repairConfig.tetraMeshSize)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.repairConfig.tetraMeshSize, "current", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("mm")])])]), _vm._v(" "), (_vm.repairConfig.tetraMeshSize.invalid) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("Please input a valid size.")]) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v("\n                                Please review your geometry carefully once the repair is complete. Repairing STL\n                                files may create unwanted changes to discreet features.\n                              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.fileRepair()
      }
    }
  }, [_vm._v("Repair File")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.fileRepairClose()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('modal', {
    ref: "resubmitjobmodal",
    attrs: {
      "name": "resubmitjobmodal",
      "pivotY": 0.2,
      "reset": true,
      "height": "auto",
      "width": "400px"
    },
    on: {
      "before-open": _vm.resubmitJobOpen
    }
  }, [_c('div', {
    staticClass: "prompt-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._v("\n                                Are you sure that you want to re-submit job?\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    on: {
      "click": function($event) {
        return _vm.resubmitJob()
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('button', {
    staticClass: "a3d btn inv",
    on: {
      "click": function($event) {
        return _vm.resubmitJobClose()
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1), _vm._v(" "), _c('estimate-cost')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.4em",
      "vertical-align": "middle"
    }
  }, [_vm._v("Jobs")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c4e0099a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4e0099a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files.vue
// module id = 493
// module chunks = 1